module.exports = __webpack_public_path__ + "static/media/1 Train-Lateral_Z2.0b14c68a.png";